import React, {useState} from 'react';
import styles from './reject-term-sheet-modal-content.module.scss';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import rejectIcon from "../../../../../../assets/order-summary-reject.svg";
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  LISTING_REJECT_ERROR,
  LISTING_REJECT_SUCCESS, TERM_SHEET_CONFIRMED, TERM_SHEET_REJECTED,
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import ListingService from "../../../../../../services/listing-service";

const RejectTermSheetModalContent = ({context, onClose}) => {
  const SUCCESS_TITLE = "TERM SHEET REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";

  const [ page, setPage ] = useState(0);
  const [ loading, setLoading] = useState(false);
  const listingService = new ListingService();
  const {termSheet, setTermSheet} = context;

  const renderConfirmResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={LISTING_REJECT_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={LISTING_REJECT_ERROR} onClose={onClose}/>
      default:
    }
  }

  const rejectTermSheet = async () => {
    setLoading(true);
    try{
      await listingService.rejectTermSheet(termSheet.applicationId);
      setTermSheet({
        ...termSheet,
        applicationStatus: TERM_SHEET_REJECTED
      })
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }

  return page === 0 ? (
    <div className={styles['reject-term-sheet']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO REJECT TERM SHEET?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Reject" src={rejectIcon} />
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button disabled={loading} onClick={() => rejectTermSheet()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'REJECT'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : renderConfirmResult()
}

export default RejectTermSheetModalContent;
